export class CoDocumentodetallePk {
    companiasocio: string;
    tipodocumento: string;
    numerodocumento: string;
    linea: number;
}

export class CoDocumentodetalle {

    pk: CoDocumentodetallePk;

    constructor() {
        this.pk = new CoDocumentodetallePk();
    }

    tipodetalle: string;
    itemcodigo: string;
    lote: string;
    condicion: string;
    descripcion: string;
    unidadcodigo: string;
    cantidadpedida: number;
    cantidadentregada: number;
    unidadcodigodoble: string;
    cantidadpedidadoble: number;
    cantidadentregadadoble: number;
    preciounitariooriginal: number;
    preciounitario: number;
    preciounitariofinal: number;
    preciounitariodoble: number;
    monto: number;
    montofinal: number;
    igvexoneradoflag: string;
    despachounidadequivalenteflag: string;
    imprimirpuflag: string;
    almacencodigo: string;
    flujodecaja: string;
    preciomodificadoflag: string;
    autorizacionnumero: number;
    exportacionmarcapaquete: string;
    exportacioncantidadembarque: number;
    exportacionfechaprogramacion: Date;
    exportacioncomentarios: string;
    exportacionsituacion: string;
    referenciafiscal02: string;
    numeroserie: string;
    documentorelactipodocumento: string;
    documentorelacnumerodocumento: string;
    documentorelaclinea: number;
    centrocosto: string;
    proyecto: string;
    porcentajedescuento01: number;
    porcentajedescuento02: number;
    porcentajedescuento03: number;
    estadodiferido: string;
    estado: string;
    ultimousuario: string;
    ultimafechamodif: Date;
    transferenciagratuitaflag: string;
    preciounitariogratuito: number;
    porcentajedescuento04: number;
    fecharequerida: Date;
    margen: number;
    vobomargenflag: string;
    porcentajedescuento05: number;
    descuento04flag: string;
    lineaitemprincipal: number;
    ordenitemprincipal: number;
    costounitario: number;
    indicadorarchivamiento: number;
    documentodespacho: string;
    cadena: string;
    clasebonificacion: string;
    cadenabonif: string;
    loteFlag: string;
    montosindscto: number;
    itemPrecioCodigo: string;
    stockActual: number;
    claselinea: string;
    familia: string;
    subfamilia: string;
    subfamiliainferior: string;
    porcentajedescuento01_Valid: number;
    porcentajedescuento02_Valid: number;
    porcentajedescuento03_Valid: number;
    porcentajedescuento04_Valid: number;
    porcentajedescuento05_Valid: number;
    costototal: number;
    limitemargen: number;
    monto01: number;
    editPrice: string;
    cantBonificacion: number;
    indbonificacion: string;
    indporcentajedescuento02_Valid: string;
    indporcentajedescuento03_valid: string;
    indporcentajedescuento04_valid: string;
    fila: number;
    filaSecuencia: number;
}
